import * as actionTypes from './actionTypes';
import axios from 'axios';
import { stringify } from 'querystring';
import { getCaseInfo } from './index';

export const addFile = (file, doc_name) => {
    return({
        type: actionTypes.Add_FILE,
        file: file,
        doc_name: doc_name,
    });
}

export const removeFile = (filename) => {
    return({
        type: actionTypes.REMOVE_FILE,
        filename: filename,
    });
}

export const uploadFileStart = () => {
    return({
        type: actionTypes.UPLOAD_FILE_START,
    });
}

export const uploadFileError = (error) => {
    return({
        type: actionTypes.UPLOAD_FILE_ERROR,
        error: error,
    });
}

export const uploadFileSuccess = () => {
    return({
        type: actionTypes.UPLOAD_FILE_SUCCESS,
    });
}

export const SetFalseUploadedSuccess = () => {
    return({
        type: actionTypes.SET_FALSE_UPLOADED_FILE_SUCCESS,
    });
}

export const SetFalseUploaded = () => {
    return (dispatch) => {  
        dispatch(uploadFileSuccess());
    };
}

export const uploadDocs = (files, caseId, userType) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/uploads-bulk`;
    const uniqueId = localStorage.getItem('token');
    return (dispatch) => {  
        const uploadFileDataArray = files.map((data, index) => ({
            uniqueId: uniqueId,
            caseId: caseId,
            doc_name: data.doc_name,
            file_name: data.file.name,
            userType: userType,
            base_data: (''+data.file.base64).split('base64,')[1],
        }));
        const payload = {
            files: uploadFileDataArray
        }
        console.log('uploadFileData: '+JSON.stringify(payload));
        sendBulkPostRequest(url, payload, dispatch, caseId, uniqueId);
    };
}

export const uploadWordDoc = (files, conversationId, caseId, userType, doc_type) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/uploadWordDoc_`;
    const uniqueId = localStorage.getItem('token');
    let uploadFileData = {};
    return (dispatch) => {
        files.forEach((data, index) => {
            getBase64(data.file, (result) => {
                uploadFileData = {
                    uniqueId: uniqueId,
                    caseId: caseId,
                    conversationId: conversationId,
                    doc_name: data.doc_name,
                    file_name: data.file.name,
                    userType: userType,
                    base_data: result,
                    doc_type: doc_type,
                };
                console.log('uploadFileData: '+JSON.stringify(uploadFileData));
                sendPostRequest(url, uploadFileData, dispatch, caseId, uniqueId);
            });
        })
    };
}

export const uploadFullPDFDoc = (files, conversationId, caseId, userType, doc_type) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/uploadFullPDFDoc`;
    const uniqueId = localStorage.getItem('token');
    let uploadFileData = {};
    return (dispatch) => {
        files.forEach((data, index) => {
            getBase64(data.file, (result) => {
                uploadFileData = {
                    uniqueId: uniqueId,
                    caseId: caseId,
                    conversationId: conversationId,
                    doc_name: data.doc_name,
                    file_name: data.file.name,
                    userType: userType,
                    base_data: result,
                    doc_type: doc_type,
                };
                console.log('uploadFileData: '+JSON.stringify(uploadFileData));
                sendPostRequest(url, uploadFileData, dispatch, caseId, uniqueId);
            });
        })
    };
}

const sendBulkPostRequest = (url, payload, dispatch, caseId, uniqueId) => {
    dispatch(uploadFileStart());
    axios.post(url, payload)
    .then((response) => {
        console.log(response);
        if(response.data === 'error' || response.data === 'failed'){
            throw (`login ${response.data}`);
        }

        dispatch(uploadFileSuccess());
        dispatch(getCaseInfo(caseId, uniqueId));
        // localStorage.setItem("currentTabPos",5)
        window.location.reload()
    })
    .catch((error) => {
        console.log(error);
        dispatch(uploadFileError(error));
    });
}

const sendPostRequest = (url, payload, dispatch, caseId, uniqueId) => {
    dispatch(uploadFileStart());
    axios.post(url, payload)
    .then((response) => {
        console.log(response);
        if(response.data === 'error' || response.data === 'failed'){
            throw (`login ${response.data}`);
        }

        dispatch(uploadFileSuccess());
        dispatch(getCaseInfo(caseId, uniqueId));
        // localStorage.setItem("currentTabPos",5)
        window.location.reload()
    })
    .catch((error) => {
        console.log(error);
        dispatch(uploadFileError(error));
    });
}

const getBase64 = (file, cb) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
        console.log(reader.result)
        let r = (reader.result).split('base64,')[1]
         cb(r)
    };
    reader.onerror = function (error) {
        console.log('Error: ', error);
    };
}

/*function getBase64(file) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onload = function() { resolve(reader.result); };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}*/

/*function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      return reader.result;
    };
    reader.onerror = function (error) {
      return error;
    };
 }*/